/**
 * @filter         blackwhite
 * @description    Gives the image a reddish-brown monochrome tint that imitates an old photograph.
 * @param amount   0 to 1 (0 for no effect, 1 for full sepia coloring)
 */
const fs = `\
vec4 blackwhite_filterColor(vec4 color, vec2 texSize, vec2 texCoord) {
    vec2 uv = texCoord;
     
    if(uv.x < 0.5){
        color = vec4(1.0 - color.r, 1.0 - color.g, 1.0 - color.b, 1.0);
    }
    
  return color;
}
`;

const uniforms = {
    amount: { value: 1, min: 0, max: 1 }
};

export default {
    name: 'blackwhite',
    uniforms,
    fs,
    passes: [{ filter: true }]
};